import React from "react";
import { Helmet } from "react-helmet";

import { xboxOnboardSiteLocationPrefix } from "@gamedev-web/partner-onboarding";

const faviconUrl = (fileName: string): string => `${xboxOnboardSiteLocationPrefix}/${fileName}`;

export const FaviconLinks: React.FC = () => (
  <Helmet>
    <link rel="icon" href={faviconUrl("favicon.ico")} />
    <link rel="icon" type="image/png" sizes="16x16" href={faviconUrl("favicon-16.png")} />
    <link rel="icon" type="image/png" sizes="32x32" href={faviconUrl("favicon-32.png")} />
    <link rel="apple-touch-icon" sizes="180x180" href={faviconUrl("favicon-180.png")} />
    <link rel="icon" type="image/png" sizes="192x192" href={faviconUrl("favicon-192.png")} />
    <link rel="icon" type="image/png" sizes="512x512" href={faviconUrl("favicon-512.png")} />
    <link rel="icon" type="image/svg+xml" href={faviconUrl("favicon.svg")} />
  </Helmet>
);
